import { GRAMMAR_LESSON_DRILL_LIMITS, GRAMMAR_MASTERY_STATES } from '@repo/config';
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import {
  grammarItemResponseSchema,
  grammarPointDetailSchema,
  grammarPointSchema,
} from '../schemas';

const grammarLessonNextDueSchema = z.object({
  nextReviewAt: z.number().int(),
  mastery: z.enum(GRAMMAR_MASTERY_STATES),
});

const getGrammarLessonV1DataSchemaDefinition = z.object({
  point: grammarPointDetailSchema,
  probeItem: grammarItemResponseSchema,
  noticeExamples: grammarPointSchema.shape.examples,
  drillItems: z
    .array(grammarItemResponseSchema)
    .min(GRAMMAR_LESSON_DRILL_LIMITS.min)
    .max(GRAMMAR_LESSON_DRILL_LIMITS.max),
  nextDue: grammarLessonNextDueSchema.nullable(),
});

export const getGrammarLessonV1DataSchema: typeof getGrammarLessonV1DataSchemaDefinition =
  getGrammarLessonV1DataSchemaDefinition;

export type IGetGrammarLessonV1Data = z.infer<typeof getGrammarLessonV1DataSchema>;

export const getGrammarLessonV1ResponseSchema: z.ZodSchema<IAPI<IGetGrammarLessonV1Data>> =
  createApiResponseSchema(getGrammarLessonV1DataSchema) as z.ZodSchema<
    IAPI<IGetGrammarLessonV1Data>
  >;

export type IGetGrammarLessonV1Response = IAPI<IGetGrammarLessonV1Data>;
